<template>
  <section class="hero is-default is-bold">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2">
            <h2 v-html="$t('viewLabos1point5Charter.title-members')" />
            <br />
            <b-notification :closable="false">
              <ul style="list-style-type: square; margin-left: 25px">
                <li style="text-align: justify">
                  {{ $t('viewLabos1point5Charter.members-li-1') }}
                </li>
                <li style="text-align: justify">
                  <span v-html="$t('viewLabos1point5Charter.members-li-2')" />
                </li>
                <li style="text-align: justify">
                  {{ $t('viewLabos1point5Charter.members-li-3') }}
                </li>
              </ul>
            </b-notification>
            <br />
            <h2 v-html="$t('viewLabos1point5Charter.title-collective')" />
            <br />
            <b-notification :closable="false">
              <ul style="list-style-type: square; margin-left: 25px">
                <li style="text-align: justify">
                  {{ $t('viewLabos1point5Charter.collective-li-1') }}
                </li>
                <li style="text-align: justify">
                  {{ $t('viewLabos1point5Charter.collective-li-2') }}
                </li>
                <li style="text-align: justify">
                  {{ $t('viewLabos1point5Charter.collective-li-3') }}
                </li>
              </ul>
            </b-notification>
            <br />
            <b-notification :closable="false">
              {{ $t('viewLabos1point5Charter.text-1') }}
              <br />
              <span v-html="$t('viewLabos1point5Charter.text-2')" />
            </b-notification>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Labos1point5Charter'
}
</script>

<style scoped>
h2 {
  font-size: 14px;
  font-weight: 500;
  padding: 0;
  line-height: 1px;
  margin: 0 0 5px 0;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #aaaaaa;
  font-family: 'Poppins', sans-serif;
}
h2::after {
  content: '';
  width: 120px;
  height: 1px;
  display: inline-block;
  background: #6c8fd6;
  margin: 4px 10px;
}
</style>
